import { ReportEmployeeWorkHoursModel } from "../../models/reports/ReportEmployeeWorkHoursModel";

export class ReportEmployeeWorkHoursCtrl {
    public static $inject = ['$scope','ReportEmployeeWorkHoursModel'];
    constructor(public $scope: any, public model: ReportEmployeeWorkHoursModel) {
        $scope.vm = this;
    }
}
